import { combineReducers, configureStore } from "@reduxjs/toolkit";
import commonReducer from "./Common/commonStore";
import dashboardReducer from "./Dashboard/dashboardStore";
import planoReducer from "./Plano/planoStore";
import gmbStoreReducer from "./Gmb/gmbStoreSlice";
import gmbProfileReducer from "./Gmb/gmbProfileSlice";
import gmbImageReducer from "./Gmb/gmbImageSlice";
import gmbVerificationReducer from "./Gmb/gmbVerificationSlice";
import gmbPostSliceReducer from "./Gmb/gmbPostSlice";
import maintenanceReducer from "./Maintenance/maintenanceSlice";

const rootReducer = combineReducers({
  dashboard: dashboardReducer,
  plano: planoReducer,
  common: commonReducer,
  gmbStore: gmbStoreReducer,
  gmbProfile: gmbProfileReducer,
  gmbImage: gmbImageReducer,
  gmbVerification: gmbVerificationReducer,
  gmbPostSlice: gmbPostSliceReducer,
  maintenance: maintenanceReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});
